import { DEFAULT_ROUTES } from '@mais-retorno-front/constants/routes';
import { ENCODED_CHAR } from '@mais-retorno-front/constants/sitemaps.constant';
import { getW3CDatefromDate } from '@mais-retorno-front/helpers/format';
import { ISitemap } from '@mais-retorno-front/models/sitemaps.model';
import { AxiosInstance } from 'axios';

interface IResponse {
  data: {
    noticias: {
      data: {
        attributes: {
          title: string;
          publishedAt: string;
          updatedAt: string;
          slug: string;
          path: string;
          thumbnail: {
            data: {
              attributes: {
                name: string;
                alternativeText: string;
                url: string;
              };
            };
          };
          categories: {
            data: {
              attributes: {
                title: string;
              };
            }[];
          };
          tags: {
            data: {
              attributes: {
                title: string;
              };
            }[];
          };
        };
      }[];
    };
  };
}

export class GetNewsToSitemapNewsUseCase {
  constructor(private readonly http: AxiosInstance) {}

  async execute(date: string): Promise<ISitemap[]> {
    const { data } = await this.http.post<IResponse>('', {
      query: `
        query noticias {
          noticias(
            filters: { publishedAt: { gt: "${date}" } }
            sort: "publishedAt:desc"
            pagination: { limit: 500 }
          ) {
            data {
              attributes {
                title
                publishedAt
                updatedAt
                slug
				        path
                thumbnail {
                  data {
                    attributes {
                      name
                      alternativeText
                      url
                    }
                  }
                }
                categories {
                  data {
                    attributes {
                      title
                    }
                  }
                }
                tags {
                  data {
                    attributes {
                      title
                    }
                  }
                }
              }
            }
          }
        }
      `,
    });

    const news = data?.data?.noticias?.data;

    if (!news || news.length === 0) {
      return [];
    }

    return news.map(({ attributes }) => {
      const keywords = [
        ...attributes?.categories.data,
        ...attributes?.tags.data,
      ];

      const keywordsWithoutAdsTags = keywords
        .map((keyword) => keyword?.attributes?.title)
        .filter((keyword) => {
          return !keyword.includes('ads');
        })
        .join(', ');

      return {
        url: `${process.env.NEXT_PUBLIC_DOMAIN}${attributes?.path}/${attributes?.slug}`,
        lastMod: `${getW3CDatefromDate(attributes?.updatedAt)}`,
        news: {
          title: attributes?.title || null,
          keywords: keywordsWithoutAdsTags,
          image: {
            title:
              attributes?.thumbnail?.data?.attributes?.name ||
              attributes?.thumbnail?.data?.attributes?.alternativeText,
            caption:
              attributes?.thumbnail?.data?.attributes?.alternativeText ||
              attributes?.thumbnail?.data?.attributes?.name,
            url: `${process.env.NEXT_PUBLIC_DOMAIN}${DEFAULT_ROUTES.nextjsApiBase}/resize-image?src=${attributes?.thumbnail?.data?.attributes?.url}${ENCODED_CHAR}w=1200${ENCODED_CHAR}h=675`,
          },
          publication: {
            language: 'pt-br',
            name: 'Mais Retorno',
            publishedAt: `${getW3CDatefromDate(attributes?.publishedAt)}`,
          },
        },
      };
    });
  }
}
